let lastScrollTop;

header = document.getElementById("header");
navbar = document.getElementById("navbar");
color = navbar?.getAttribute('data-color') ? navbar?.getAttribute('data-color') : 'black';

if (navbar && header) {
  window.addEventListener("scroll", function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= header.scrollHeight) {
      navbar.className = "navbar navbar--fixed navbar--theme-black";
    } else {
      navbar.className = "navbar navbar--transparent navbar--theme-" + color;
    }
  });
}
